import React from "react";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpFromBracket, faSquarePlus } from "@fortawesome/free-solid-svg-icons";

/**
 * The iOS "Add to Home Screen" recipe. iOS Safari has no programmatic install
 * prompt, so we walk the user through the Share-sheet flow. Shared by the
 * floating install banner and the pending-actions panel.
 */
const Steps = styled.ol`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 0.9rem;
  line-height: 1.35;
  color: #223126;
`;

const Step = styled.li`
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    flex-shrink: 0;
    color: #1a1a1a;
  }
`;

const Num = styled.span`
  flex-shrink: 0;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #1a1a1a;
  color: #fff;
  font-size: 0.72rem;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

const IosInstallSteps: React.FC = () => (
  <Steps>
    <Step>
      <Num>1</Num>
      <span>
        Tap the <strong>Share</strong> button{" "}
        <FontAwesomeIcon icon={faArrowUpFromBracket} /> in Safari's bottom bar.
      </span>
    </Step>
    <Step>
      <Num>2</Num>
      <span>
        Scroll down and tap <strong>Add to Home Screen</strong>{" "}
        <FontAwesomeIcon icon={faSquarePlus} />.
      </span>
    </Step>
    <Step>
      <Num>3</Num>
      <span>
        Tap <strong>Add</strong> — then open NΛSOS from its new icon. ✨
      </span>
    </Step>
  </Steps>
);

export default IosInstallSteps;
